import { getAmplitudeInstance } from '../amplitudeHelpers';

/**
 * The user taps the 'Forgot your password?' prompt on the login modal.
 */
const logLogInScreenForgotPasswordTapped = (callback?: () => void) => {
  getAmplitudeInstance().logEvent('log in screen forgot password tapped', {}, callback);
};

export default logLogInScreenForgotPasswordTapped;
